import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Quotes.css';
import SearchBar from 'components/shared/navigation/SearchBar';
import SimpleTable from 'components/shared/table/SimpleTable';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import {
  closeModal,
  loadQuotesRequest,
  selectQuoteRequest,
} from 'actions/admin/quotes/quotes';
import {
  getCurrentPage,
  getQuotes,
  getSelectedQuoteIndex,
  getTaskImages,
} from 'selectors/admin/quotes/quotes';
import SimpleText from 'components/shared/text/SimpleText';
import Number from 'components/shared/text/Number';
import numeral from 'numeral';
import QuoteStatus from 'components/shared/table/cell-addons/QuoteStatus';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import QuoteDetailsModal from './QuoteDetailsModal';
import { simpleScrollToTop } from 'services/utils/scroller-util';

class Quotes extends Component {
  tabSelection = 1;

  componentDidMount() {
    this.props.dispatch(loadQuotesRequest(1, undefined, undefined, true));
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handleNavSelect = (id) => {
    this.tabSelection = id;
    this.loadQuotes(id, 1);
  };

  handlePageChange = (newPage) => {
    this.loadQuotes(this.tabSelection, newPage);
  };

  loadQuotes(tabSelection, newPage) {
    switch (tabSelection) {
      case 1:
        this.props.dispatch(loadQuotesRequest(newPage));
        break;

      case 2:
        this.props.dispatch(loadQuotesRequest(newPage, true, undefined, true));
        break;

      case 3:
        this.props.dispatch(loadQuotesRequest(newPage, undefined, true, true));
        break;

      default:
    }
  }

  handleRowSelection = (index) => {
    this.props.dispatch(
      selectQuoteRequest(index, this.props.quotes.content[index].task.id)
    );
  };

  handleCloseModal = () => {
    this.props.dispatch(closeModal());
  };

  render() {
    return (
      <div className="quotes">
        <div className="full-title">Quotes</div>

        {this.props.quotes !== null && (
          <div className="content-container">
            <SearchBar>
              <NavigationBar
                items={[
                  {
                    id: 1,
                    title: 'All',
                  },
                  {
                    id: 2,
                    show: this.props.quotes.totalWaiting > 0,
                    title: 'Waiting',
                    total: this.props.quotes.totalWaiting,
                  },
                  {
                    id: 3,
                    show: this.props.quotes.totalDenied > 0,
                    title: 'Denied',
                    total: this.props.quotes.totalDenied,
                  },
                ]}
                onSelected={this.handleNavSelect}
              />
            </SearchBar>

            <SimpleTable
              className="quotes-table"
              headers={[
                'WO #',
                'NAME',
                'CLIENT NAME',
                'LOCATION',
                'CONTRACTOR',
                'TRADE',
                'STATUS',
                'AMOUNT',
              ]}
              rows={this.mapQuotes(this.props.quotes.content)}
              emptyMessage="No Quotes"
              onRowSelected={this.handleRowSelection}
            />

            <div className="pagination-container">
              <SimplePagination
                currentPage={this.props.currentPage}
                pageSize={this.props.quotes.pageSize}
                total={this.props.quotes.total}
                onPageChange={this.handlePageChange}
              />
            </div>
          </div>
        )}

        {this.props.selectedQuoteIndex !== null && (
          <QuoteDetailsModal
            quote={this.props.quotes.content[this.props.selectedQuoteIndex]}
            show={this.props.selectedQuoteIndex !== null}
            taskImages={this.props.taskImages}
            workOrder={
              this.props.quotes.content[this.props.selectedQuoteIndex]
                .work_order
            }
            onClose={this.handleCloseModal}
          />
        )}
      </div>
    );
  }

  mapQuotes = (quotes) => {
    return quotes.map((quote) => {
      return [
        `${quote.work_order.number}-${numeral(quote.task.number).format('00')}`,
        quote.work_order.name !== null ? quote.work_order.name : 'N/A',
        <span className="h4">{quote.work_order.client.company_name}</span>,
        <SimpleText
          lines={[
            quote.work_order.building.location.street_address_1,
            quote.work_order.building.location.city,
          ]}
        />,
        <span className="h4">{quote.contractor_name}</span>,
        quote.task.trade.label,
        <QuoteStatus status={quote.status} />,
        quote.estimate != null ? (
          <Number value={quote.estimate} format="$0,0" />
        ) : (
          'TBD'
        ),
      ];
    });
  };
}

export default connect((state) => {
  return {
    currentPage: getCurrentPage(state),
    quotes: getQuotes(state),
    selectedQuoteIndex: getSelectedQuoteIndex(state),
    taskImages: getTaskImages(state),
  };
})(Quotes);



// WEBPACK FOOTER //
// ./src/components/admin/quotes/Quotes.js